// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../../../node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("../../images/tunnel/sabrina.jpg");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div class=\"row\"> <div class=\"question\"> <span> <div> <img class=\"avatar\" alt=\"avatar\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> </div> </span> <div class=\"yours messages\"> <div class=\"message last test\"> <span class=\"content-question\">This is a question</span></div> </div> </div> </div> ";
// Exports
module.exports = code;